export const ASSET_TYPE_WITH_DEPRICIATION = [
    { text: 'Building', value: 'building', depriciation: false },
    { text: 'Computer & Parts', value: 'computerParts', depriciation: [5, 10, 15, 20, 25, 30, 40]},
    { text: 'Electrical Equipments', value: 'electricalEquipments', depriciation: [5, 10, 15, 20, 25, 30, 40] },
    { text: 'Furniture & Fittings', value: 'furniture', depriciation: [5, 10, 15, 20, 25, 30, 40] },
    { text: 'Heavy Machinery and Plant', value: 'heavyMachinery', depriciation: [15, 20, 30, 40, 45, 60] },
    { text: 'Investments', value: 'investments', depriciation: false },    
    { text: 'Intangible Assets', value: 'intangibleAssets', depriciation: 25 },
    { text: 'Land', value: 'land', depriciation: false },
    { text: 'Plant and Machinery', value: 'plantMachinery', depriciation: [15, 20, 30, 40, 45, 60] },    
    { text: 'Vehicle', value: 'vehicle', depriciation: [5, 10, 15, 20, 25, 30, 40] },
]

export const ASSET_CATEGORY = [
    { text: 'Business', value: 'business' },
    { text: 'Personal', value: 'personal' },
    { text: 'Business & Personal', value: 'b&p' },
];

export const ASSET_PURCHASE_TYPE = [
    { text: 'Downpayment', value: 'downpayment' },
    { text: 'Partial', value: 'partial' },
    { text: 'Installment', value: 'installment' }
];

export const PAYMENT_OPTIONS = [
    { text: 'Cash', value: 'Cash' }, 
    { text: 'Bank Account', value: 'Bank Account' }, 
    { text: 'Cash & Bank Account', value: 'CashAndBank Account' }
]

export const getFinancialYear = () => {
    //get current date
    var today = new Date();
    
    //get current month
    var curMonth = today.getMonth();
    
    var fiscalYr = "";
    if (curMonth > 3) { //
        var nextYr1 = (today.getFullYear() + 1).toString();
        fiscalYr = today.getFullYear().toString() + "-" + nextYr1;
    } else {
        var nextYr2 = today.getFullYear().toString();
        fiscalYr = (today.getFullYear() - 1).toString() + "-" + nextYr2;
    }
    return fiscalYr;
}



// WEBPACK FOOTER //
// ./src/components/InvoiceManagement/tabs/utils.js